import { render, staticRenderFns } from "./GuardiansList.vue?vue&type=template&id=63ed3da5&"
import script from "./GuardiansList.vue?vue&type=script&lang=js&"
export * from "./GuardiansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports